import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/pages/home/home.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { AboutComponent } from './components/pages/about/about.component';
import { GalleryComponent } from './components/pages/gallery/gallery.component';
import { LoginComponent } from './components/pages/login/login.component';
import { BlogTwoComponent } from './components/pages/blog/blog-two.component';
import { BlogDetailsComponent } from './components/pages/blog-details/blog-details.component';
import { ErrorComponent } from './components/pages/error/error.component';
import { MediaServiceComponent } from './components/pages/media-service/media-service.component';
import { SportsServiceComponent } from './components/pages/sports-service/sports-service.component';
import { AdminEventComponent } from './components/pages/admin-pages/admin-event/admin-event.component';
import { AdminBlogsComponent } from './components/pages/admin-pages/admin-blogs/admin-blogs.component';
import { AdminCourseComponent } from './components/pages/admin-pages/admin-course/admin-course.component';
import { HomeLayoutComponent } from './components/layouts/content-layout/home-layout/home-layout.component';
import { AdminLayoutComponent } from './components/layouts/content-layout/admin-layout/admin-layout.component';
import { AuthGuard } from './services/auth-guard.service';
import { PrivacyPolicyComponent } from './components/pages/privacy-policy/privacy-policy.component';

const routes: Routes = [
    {
        path: '', component: HomeLayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
            { path: 'about', component: AboutComponent },
            { path: 'gallery', component: GalleryComponent },
            { path: 'blogs', component: BlogTwoComponent },
            { path: 'blog-details', component: BlogDetailsComponent },
            { path: 'error', component: ErrorComponent },
            { path: 'contact', component: ContactComponent },
            { path: 'media-service', component: MediaServiceComponent },
            { path: 'sports-service', component: SportsServiceComponent },
            { path: 'privacy-policy', component: PrivacyPolicyComponent }
        ]
    },
    {
        path: 'admin', component: AdminLayoutComponent,
        canActivate: [AuthGuard], canActivateChild: [AuthGuard],
        children: [
            { path: 'admin-events', component: AdminEventComponent },
            { path: 'admin-blogs', component: AdminBlogsComponent },
            { path: 'admin-courses', component: AdminCourseComponent },
        ]
    },
    { path: 'admin-login', component: LoginComponent },
    { path: '**', component: ErrorComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }